export const registerCn = {
    sjhm:"手机号码：",
    qsrsjhm:"请输入手机号码",
    yzm:"验证码：",
    qsryzm:"请输入验证码",
    fsyzm:"发送验证码",
    jsts:"秒后重新发送",
    zcxy:"《贸促通产品检测认证平台注册协议》",
    yxzc:"邮箱注册",
    wxzc:"微信注册",
    nicheng:"昵称：",
    nichengtishi:"请输入您的昵称",
    szmm:"设置密码",
    zcsrma:"再次输入密码",
    chenggongtishi:"恭喜您！您已成功注册为贸促通产品检测认证平台会员！ 使用中如遇到任何问题，请及时联系平台客服！",
    dengluzhanghu:"登录账户：",
    lijidenglu:"立即登录"
}


// WEBPACK FOOTER //
// ./src/lang/home/register/indexCn.js